import { render, staticRenderFns } from "./FileSystemBrowser.vue?vue&type=template&id=22c16ab4&scoped=true&"
import script from "./FileSystemBrowser.vue?vue&type=script&lang=ts&"
export * from "./FileSystemBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./FileSystemBrowser.vue?vue&type=style&index=0&id=22c16ab4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c16ab4",
  null
  
)

export default component.exports